// Select Pickup contact/location
export const TAB_DATA_PICKUP_LOCATION_VAR_LATER = 'later'
export const TAB_DATA_PICKUP_LOCATION_VAR_SAME = 'same'
// Select Mapping/batchTemplate
export const TAB_DATA_MAPPING_VAR_NEW = 'new'
export const TAB_DATA_MAPPING_VAR_EDIT = 'edit'

export const PICKUP_OPTIMISED_TIME = 'optimised_time'
export const PICKUP_EXACT_TIME = 'exact_time'
